import FieldsGridRowWrapper from '../FieldsGridRowWrapper';
import { formatToUSDateTimeWith12Hour } from 'utils/dateTimeUtils/dateFormatUtil';

import GridText from 'components/text/GridText';
import TableLink from 'components/text/TableLink';

import usePageRoutes from 'hooks/usePageRoutes';

import { TEST_ID } from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const FieldsGridRow = ({
    id,
    lastActivity,
    lastEdited,
    name,
    ref,
    style,
    testId = TEST_ID
}: Props) => {
    const { fieldDetailsPage } = usePageRoutes();

    return (
        <FieldsGridRowWrapper ref={ref} style={style} testId={testId}>
            <TableLink className={styles.tableLink} text={name} to={fieldDetailsPage(id)} />

            <GridText text={formatToUSDateTimeWith12Hour(lastEdited) ?? '-'} />

            <GridText text={lastActivity ?? '-'} />
        </FieldsGridRowWrapper>
    );
};

export default FieldsGridRow;
